<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Routes</h1>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    @input="updateRows"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs6 class="text-right">
                <v-btn color="primary" dark @click="createRouteProcess">Add Route</v-btn>
                <v-btn color="primary" outlined class="ml-2" dark :to="'/management/routes/active'">Active</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="displayRoutes"
                        item-key="`${name} ${id}`"
                        :server-items-length="numDisplayRoutes"
                        :options.sync="options"
                        class="elevation-1">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="primary"
                                        @click="openRouteDetails(item)">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Route Information</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="green"
                                        @click="restoreRoute(item)">
                                        mdi-restore
                                    </v-icon>
                                </template>
                                <span>Restore Route</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="red"
                                        @click="deleteRoute(item)">
                                        delete_forever
                                    </v-icon>
                                </template>
                                <span>Delete Route</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <restore-route :toggle="toggleRestore" :show-dialog="restoreDialog" :route="selectedRoute"></restore-route>
            <route-details :action-type="detailsType" :toggle="toggleRouteDetails" :show-dialog="routeDetails" :show-remove-task-dialog="removeTaskFromRoute" :show-remove-user-dialog="removeUserFromTask" :show-task-details-dialog="editTaskDetails"></route-details>
            <unassign-task :show-dialog="removeTaskDialog" :toggle="toggleRemoveTaskDialog" :job-task="selectedDetailsTask"></unassign-task>
            <task-details :job-task="selectedDetailsTask" :show-dialog="taskDetailsDialog" :toggle="toggleTaskDetailsDialog"></task-details>
            <remove-user-from-task :show-dialog="removeUserDialog" :toggle="toggleRemoveUserDialog" :user="selectedUser"></remove-user-from-task>
            <delete-route :showDialog="deleteDialog" :toggle="toggleDelete" :route="selectedRoute"></delete-route>
        </v-layout>
    </v-container>
</template>
<script>
    import RestoreRoute from '../../../../components/routes/Restore'
    import DeleteRoute from '../../../../components/routes/Delete'
    import RouteDetails from '../../../../components/routes/Details'
    import {mapActions, mapGetters} from 'vuex'
    import UnassignTask from "../../../../components/jobTasks/UnassignTask";
    import RemoveUserFromTask from "../../../../components/users/RemoveUserFromTask";
    import Helpers from "../../../../utils/helpers/routeHelpers";
    import TaskDetails from "../../../../components/jobTasks/Details";

    export default {
        name: 'archived-routes',
        components: {
            RemoveUserFromTask,
            TaskDetails,
            RestoreRoute,
            DeleteRoute,
            UnassignTask,
            RouteDetails
        },
        created () {
            this.getRouteRange({keywords: '', limit: 10, offset: 0})
            this.getArchivedCount()
        },
        data () {
            return {
                restoreDialog: false,
                routeDetails: false,
                removeTaskDialog: false,
                taskDetailsDialog: false,
                removeUserDialog: false,
                deleteDialog: false,
                selectedUser: null,
                routeForDetails: null,
                selectedDetailsTask: null,
                tableKey: 0,
                detailsType: '',
                search: '',

                options: {},
                displayRoutes: [],
                numDisplayRoutes: 0,
            }
        },
        methods: {
            ...mapActions({
                getIsolatedRoute: 'routes/getIsolatedRoute',
                selectRoute: 'routes/selectRoute',
                clearSelectedRoute: 'routes/clearSelectedRoute',
                completeTask: 'jobTasks/complete',
                getRouteRange: 'routes/getArchivedRange',
                getArchivedCount: 'routes/getArchivedCount'
            }),
            async createRouteProcess () {
                this.clearSelectedRoute()
                let route = {
                    name: null,
                    id: null,
                    duration: '00:00:00',
                    color: Helpers.getRandomColour(),
                    jobTasks: [],
                    userRoutes: [],
                }
                this.detailsType = 'create'
                this.selectRoute(route)
                this.toggleRouteDetails()
            },
            async removeTaskFromRoute (task) {
                this.selectedDetailsTask = task
                await this.toggleRemoveTaskDialog()
            },
            async removeUserFromTask (user) {
                this.selectedUser = user
                await this.toggleRemoveUserDialog()
            },
            toggleRemoveTaskDialog () {
                this.removeTaskDialog = !(this.removeTaskDialog)
            },
            async editTaskDetails (task) {
                this.selectedDetailsTask = task
                await this.toggleTaskDetailsDialog()
            },
            toggleTaskDetailsDialog () {
                this.taskDetailsDialog = !(this.taskDetailsDialog)
            },
            getCrewNames(route) {
                let members = []
                route.userRoutes.forEach(userRoute => {
                    members.push(userRoute.user.firstName)
                })
                return members.toString()
            },
            async deleteRoute(route) {
                await this.selectRoute(route)
                await this.toggleDelete()
            },
            async openRouteDetails(item) {
                this.getIsolatedRoute(item.id)
                this.detailsType = 'update'
                await this.toggleRouteDetails()
            },
            async restoreRoute(route) {
                await this.selectRoute(route)
                await this.toggleRestore()
            },
            toggleRestore () {
                if(this.restoreDialog){
                    this.updateRows()
                }
                this.restoreDialog = !(this.restoreDialog)
            },
            toggleRouteDetails () {
                if(this.routeDetails){
                    this.updateRows()
                }
                this.routeDetails = !(this.routeDetails)
            },
            toggleDelete() {
                if(this.deleteDialog){
                    this.updateRows()
                }
                this.deleteDialog = !(this.deleteDialog)
            },
            toggleRemoveUserDialog () {
                this.removeUserDialog = !(this.removeUserDialog)
            },
            updateRows(){
                let limit = this.options.itemsPerPage
                let offset = this.options.itemsPerPage * (this.options.page - 1)
                //picking 'all' sets limit to -1 so we can handle that here
                if(limit < 0){
                    limit = this.archivedCount
                    offset = 0
                }
                this.getArchivedCount()
                this.getRouteRange({keywords: this.search, limit: limit, offset: offset})
            }
        },
        computed: {
            ...mapGetters({
                routeRange: 'routes/archivedRange',
                selectedRoute: 'routes/selectedRoute',
                incompleteTasks: 'routes/selectedRouteIncompleteTasks',
                headers: 'routes/headers',
                error: 'routes/error',
                routeCount: 'routes/archivedCount',

            }),
        },
        watch: {
            routeRange: function (routes) {
                if(!routes){
                    this.displayRoutes = []
                    this.numDisplayRoutes = 0
                    return
                }
                if (!Array.isArray(routes)) {
                    this.displayRoutes = [routes]
                } else {
                    this.displayRoutes = routes
                }
                this.displayRoutes.forEach((route) => {
                    let completionStatus = true
                    route.jobTasks.forEach((jt) => {
                        completionStatus = completionStatus && (jt.status === 'Complete')
                        route.complete = completionStatus
                    })
                })
                this.displayRoutes.map(route => {
                    route.crew = Helpers.getCrewNames(route)
                    route.complete = Helpers.getCompletionStatus(route)
                })
                this.numDisplayRoutes = this.routeCount
            },
            options: {
                handler () {
                    this.updateRows()
                },
                deep: true,
            },
            routeCount: function (){
                this.numDisplayRoutes = this.routeCount
            }
        },
    }
</script>
